import React, { PureComponent } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withCookies } from "react-cookie";
import { actProductCategoryListFetch } from "actions/productCategoryActions";
import { actISourceCreateBuyerRequest } from "../actions";
import BuyerForm from "./view";

class BuyerFormContainer extends PureComponent {
    render() {
        return <BuyerForm {...this.props} />;
    }
}

const mapStateToProps = (state, { cookies }) => ({
    productCategories: state.productCategoryList.data,
});

const mapDispatchToProps = dispatch => ({
    onSubmit: bindActionCreators(actISourceCreateBuyerRequest, dispatch),
    onFetchProduct: bindActionCreators(actProductCategoryListFetch, dispatch),
});

BuyerFormContainer.propTypes = {
    profile: PropTypes.oneOfType([PropTypes.object]).isRequired,
    onFetchProduct: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
};

export default withCookies(
    withRouter(connect(mapStateToProps, mapDispatchToProps)(BuyerFormContainer))
);
